export default __webpack_public_path__ + "static/media/5-remoto.ed4bd724.svg";